var React = require('react');

function CautionIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E1FF50"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M20.461.11c.2.099.362.26.462.46L39.89 38.508c.255.51.048 1.13-.462 1.384-.143.072-.3.109-.461.109H1.032C.462 40 0 39.538 0 38.968c0-.16.037-.318.109-.461L19.077.57c.255-.51.875-.717 1.384-.462zM20 2.5L2.5 38h35L20 2.5zm0 5L34 36H6L20 7.5zM20 30c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2zm1.5-13h-3l1 12h1l1-12z","transform":"translate(-782 -1691) translate(758 1659) translate(24 32)"}))))));
}

CautionIcon.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = CautionIcon;

CautionIcon.default = CautionIcon;
